import React, { Fragment } from "react";
import { styled } from "@mui/material/styles";
import { useHistory } from "react-router-dom";
import { Avatar, Typography, Card, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import Document from "../../assets/-_Document management.png";

const StyledWrapMenuApp = styled("div")(({}) => ({
  paddingBottom: 80,
}));

const StyledCard = styled(Card)({
  boxShadow: "none",
  borderRadius: 16,
  border: "1px solid #919eab3d",
  margin: 8,
  "&:hover": {
    cursor: "pointer",
    transition:
      "color 0.15s ease-in-out,box-shadow 0.15s ease-in-out,transform 0.15s ease-in-out",
    transform: "translateY(-5px)",
  },
  "& .inner": {
    padding: 16,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxSizing: "border-box",
    "& div": {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      alignItems: "center",
    },
    "& .MuiTypography-subtitle": {
      fontSize: 18,
      lineHeight: 1.2,
    },
    "& .MuiAvatar-root": {
      width: 150,
      height: 100,
      marginBottom: 16,
      "& img": {
        objectFit: "contain",
      },
    },
  },
});

const menuReport = {
  workingtime: [
    {
      id: "reportWorkingTime",
      name: "reportWorkingTime",
      icon: Document,
    },
    {
      id: "ReportAttendance",
      name: "ReportAttendance",
      icon: Document,
    },
  ],
  overtime: [
    {
      id: "SummaryOTandShift",
      name: "SummaryOTandShift",
      path: "/manager/report/summary-ot-shift",
      icon: Document,
    },
    {
      id: "OtMonitoring",
      name: "OtMonitoring",
      path: "/manager/otmonitoring",
      icon: Document,
    },
  ],
  leave: [
    {
      id: "summarizeAbsent",
      name: "summarizeAbsent",
      path: "/manager/report/leave-absent-late",
      icon: Document,
    },
    {
      id: "QuotaOnLeave",
      name: "QuotaOnLeave",
      path: "/manager/report/quota-leave-list",
      icon: Document,
    },
  ],
};

const MenuApp = (props) => {
  const { setView, handleOpen } = props;
  const history = useHistory();
  const { t } = useTranslation();

  const handleClickMenu = (menu) => {
    if (!menu.id) return;

    if (menu.path) {
      history.push(menu.path);
      return;
    }

    handleOpen();
    setView(menu.name);
  };

  return (
    <Fragment>
      <StyledWrapMenuApp>
        <Grid container spacing={4}>
          <Grid item xs={12} container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">
                <i
                  className="fa-solid fa-briefcase"
                  style={{ marginRight: "16px" }}
                ></i>
                {t("WorkingTime")}
              </Typography>
            </Grid>
            {menuReport.workingtime.map((value, index) => (
              <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
                <StyledCard onClick={() => handleClickMenu(value)}>
                  <div className="inner">
                    <Avatar variant="rounded" src={value.icon} />
                    <div>
                      <Typography align="center" variant="subtitle" gutterBottom>
                        {t(value.name)}
                      </Typography>
                    </div>
                  </div>
                </StyledCard>
              </Grid>
            ))}
          </Grid>

          <Grid item xs={12} container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">
                <i
                  className="fa-solid fa-briefcase"
                  style={{ marginRight: "16px" }}
                ></i>
                {t("Overtime")}
              </Typography>
            </Grid>
            {menuReport.overtime.map((value, index) => (
              <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
                <StyledCard onClick={() => handleClickMenu(value)}>
                  <div className="inner">
                    <Avatar variant="rounded" src={value.icon} />
                    <div>
                      <Typography align="center" variant="subtitle" gutterBottom>
                        {t(value.name)}
                      </Typography>
                    </div>
                  </div>
                </StyledCard>
              </Grid>
            ))}
          </Grid>

          <Grid item xs={12} container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">
                <i
                  className="fa-solid fa-umbrella-beach"
                  style={{ marginRight: "16px" }}
                ></i>
                {t("SummaryOfLeaveAndAbsences")}
              </Typography>
            </Grid>
            {menuReport.leave.map((value, index) => (
              <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
                <StyledCard onClick={() => handleClickMenu(value)}>
                  <div className="inner">
                    <Avatar variant="rounded" src={value.icon} />
                    <div>
                      <Typography align="center" variant="subtitle" gutterBottom>
                        {t(value.name)}
                      </Typography>
                    </div>
                  </div>
                </StyledCard>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </StyledWrapMenuApp>
    </Fragment>
  );
};

export default MenuApp;
